import React, { useState, useEffect } from 'react';
import FAQPage from './FAQPage';
import contentfulClient from '../../utilities/contentful';

const FAQPageContainer = () => {
  const [content, setContent] = useState({});

  const fetchContent = async id => {
    const res = await contentfulClient.getEntries({
      content_type: 'faqPage2',
      'sys.id': id,
      include: 2,
    });

    const { fields } = res.items[0];
    setContent(fields);
  };

  useEffect(() => {
    fetchContent('7CG39c3oqM78wkzbYk8xnM');
  }, []);

  return <FAQPage content={content} />;
};

export default FAQPageContainer;
